export default function copyToClipboard(targetElement) {
  const copyText = targetElement.href;
  document.addEventListener('copy', (e) => {
    e.clipboardData.setData('text/plain', copyText);
    e.preventDefault();
  }, true);
  document.execCommand('copy');
}
